<form>
    <div class="label-text">{{ subtitle(2008) +':' }}</div>
    <div class="time-text">{{ showTime('from') }}</div>
    <div class="slider-row">
        <hold-wrapper
                (onAction)="settingsNotifications.changeTime('from', -1)">
            <div class="slider-icon">
                <img ngSrc="/assets/img/icons/minus-simple.svg"
                     priority="true" width="20" height="20" alt=""/>
            </div>
        </hold-wrapper>
        <input class="slider cursor-pointer"
            type="range"
            [ngModelOptions]="{standalone: true}"
            (ngModelChange)="settingsNotifications.changeSliderValue('from', $event)"
            [ngModel]="settingsNotifications.getTime('from')"
            min="0" max="1439" step="1" />
        <hold-wrapper
                (onAction)="settingsNotifications.changeTime('from', 1)">
            <div class="slider-icon">
                <img ngSrc="/assets/img/icons/plus-simple.svg"
                     priority="true" width="20" height="20" alt=""/>
            </div>
        </hold-wrapper>
    </div>

    <div class="label-text">{{ subtitle(2009) +':' }}</div>
    <div class="time-text">{{ showTime('to') }}</div>
    <div class="slider-row">
        <hold-wrapper
                (onAction)="settingsNotifications.changeTime('to', -1)">
            <div class="slider-icon">
                <img ngSrc="/assets/img/icons/minus-simple.svg"
                     priority="true" width="20" height="20" alt=""/>
            </div>
        </hold-wrapper>
        <input class="slider slider-thumb cursor-pointer"
               type="range"
               [ngModelOptions]="{standalone: true}"
               (ngModelChange)="settingsNotifications.changeSliderValue('to', $event)"
               [ngModel]="settingsNotifications.getTime('to')"
               min="0" max="1439" step="1" />
        <hold-wrapper
                (onAction)="settingsNotifications.changeTime('to', 1)">
            <div class="slider-icon">
                <img ngSrc="/assets/img/icons/plus-simple.svg"
                     priority="true" width="20" height="20" alt=""/>
            </div>
        </hold-wrapper>
    </div>

    <div class="time-range-wrapper">
        <img class="invert" ngSrc="/assets/img/id_icons/81.svg"
             priority="true" width="24" height="24" alt=""/>
        <div class="time-range">
                {{ settingsNotifications.hoursDifference + ' ' + subtitle(283) + ' ' +
                settingsNotifications.minutesDifference + ' ' + subtitle(414) }}
        </div>
    </div>

    <form-action-buttons>
        <form-button [subtitle]="subtitle(71)"
                     [btnType]="'cancel'"
                     (click)="closeForm()">
        </form-button>
        <form-button [subtitle]="subtitle(1255)"
                     [btnType]="'confirm'"
                     (click)="setNotificationTime()">
        </form-button>
    </form-action-buttons>
</form>
